// This tiny helper is just to help with legibility
export const isBrowser = typeof window !== "undefined";
